
<app-navbar></app-navbar>
<div class="page-title-area page-title-bg1 upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2 >{{'Order_Tracking' | translate }}</h2>

            <!--<a routerLink="/">{{'Home' | translate }}</a>-->
        </div>
    </div>
</div>
<!-- End -->
<!-- Start Order Tracking Area -->
<section class="order-tracking-area ptb-100">
    <div class="container">
        <div class="order-tracking-content">

            <!--data-aos="fade-up" data-aos-delay="100"-->
            <div class="form-group">
                <label>{{'Order_No' | translate }}</label>
                <input type="text" class="form-control" #orderNo name="orderNo">
            </div>

            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <div class="form-group">
                <label>{{'Phone_No' | translate }} </label><br />
                <input type="text" required ng2TelInput #phone_number name="phone_number" class="form-control" (countryChange)="onCountryChange($event)" [ng2TelInputOptions]="telOptions" />
            </div>
            <br />
            <!--data-aos="fade-up" data-aos-delay="100" -->
            <button type="button" class="default-btn" (click)="onTrack(orderNo.value,phone_number.value)">{{'Track_Order' | translate }}</button>

        </div>
    </div>
</section>
<!-- <section class="contact-area ptb-100">
    <div class="container">
        <div class="col-lg-12 col-md-6">
            <div class="form-group mb-3">
                <div class="select-box">
                    <div class="form-group">
                        <label>{{'Order_No' | translate }}</label>
                        <input type="text" class="form-control" #orderNo name="orderNo">
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12 col-md-6">
            <div class="form-group mb-3">
                <div class="select-box">
                    <div class="form-group">
                        <label>{{'Phone_No' | translate }} </label><br />
                        <input type="text" required ng2TelInput #phone_number name="phone_number" class="form-control" (countryChange)="onCountryChange($event)" [ng2TelInputOptions]="telOptions" />
                    </div>
                    </div>
                    </div>
                    </div>
                    <br />
                    <button type="button" class="default-btn" (click)="onTrack(orderNo.value,phone_number.value)">{{'Track_Order' | translate }}</button>

                </div>
</section>
 -->
